import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { AuthHttp } from "angular2-jwt/angular2-jwt";
import { Headers, Http, Response, RequestOptions, ResponseContentType } from '@angular/http';
import { ClienteXCiudad, MenuXUsuario } from "../login/cliente_login";
import { ConstantService } from "../../components/common/utils/constant.service";

@Injectable()
export class AdministracionContatosService {
       private url="login";
      
    constructor(public authHttp: AuthHttp) { 
         let constantService = new ConstantService();  
        this.url = constantService.API_ENDPOINT + this.url;
    }

    consultarConctactosClienteMenu(cliente: ClienteXCiudad): Observable<MenuXUsuario[]> {
        let body = JSON.stringify(cliente);
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization' : "Token " + sessionStorage.getItem("Token") });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.post(this.url + "/consultarContactosClienteMenu", body, options).map(this.extractData)
            .catch(this.handleError);
    }

    guardarCambiosUsuarios(usuarios: MenuXUsuario[]): Observable<boolean[]> {
        let body = JSON.stringify(usuarios);
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization' : "Token " + sessionStorage.getItem("Token") });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.post(this.url + "/guardarCambiosUsuarios", body, options).map(this.extractData)
            .catch(this.handleError);
    }

    private extractData(res: Response) {
        let body = res.json();
        return body || {};
    }
    private handleError(error: any) {
        return Observable.throw(error);
    }
}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/administracion-contactos/administracion-contactos.service.ts